<div id="forms" class="page-layout simple fullwidth" fxLayout="column">
    <!-- HEADER -->
    <div
        class="header p-24"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        [ngClass]="{
            fundo_acent: existingType == '1',
            fundo_amarelo: existingType == '2',
            fundo_azul: existingType == '3',
        }"
    >
        <div fxLayout="column" fxLayoutAlign="center start">
            <div fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="secondary-text s-18">home</mat-icon>
                <mat-icon class="secondary-text s-16">chevron_right</mat-icon>
                <span class="secondary-text pointer" (click)="retornarLista()">{{ retornoLista }} </span>
            </div>
            <div class="h1 mt-16" style="color: #fff !important">{{ titulo }}</div>
        </div>

        <button
            mat-mini-fab
            matTooltip="Salvar"
            color="green"
            class="save-product-button"
            [disabled]="isInvalidForm()"
            (click)="openConfirmaBoleta()"
        >
            <mat-icon>save</mat-icon>
        </button>
    </div>
    <!-- END HEADER-->

    <div class="content p-24">
        <form fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="form">
            <div fxLayout="row" fxLayoutAlign="start" fxFlex="1 0 auto">
                <div class="mat-card mat-elevation-z4 p-24 mr-24" style="width: 50%; float: left">
                    <div class="h2 mb-24">Escolha um cliente</div>

                    <div fxLayout="row" fxLayoutAlign="space-between">
                        <mat-form-field appearance="outline" fxFlex="100">
                            <mat-label>Cliente</mat-label>
                            <input
                                matInput
                                placeholder="Digite o nome ou conta de um cliente"
                                aria-label="Cliente"
                                [formControl]="cliente"
                                name="cliente"
                                required
                                [matAutocomplete]="auto"
                            />
                            <mat-autocomplete
                                #auto="matAutocomplete"
                                [displayWith]="displayFn"
                                (optionSelected)="getCliente($event.option.value)"
                            >
                                <mat-option *ngFor="let cliente of filteredClients | async" [value]="cliente">
                                    <span> {{ cliente.nome }}</span> |
                                    <small>Conta: {{ cliente.numero_xp }} | </small>
                                    <small
                                        >Assessor:
                                        {{ cliente.assessor != undefined ? cliente.assessor.name : "Sem Assessor" }}
                                    </small>
                                </mat-option>
                            </mat-autocomplete>
                            <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
                            <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <br />

            <div fxLayout="row" fxLayoutAlign="space-between" fxFlex="1 0 auto">
                <div class="mat-card mat-elevation-z4 p-24 mr-24" style="width: 50%; float: left">
                    <div class="h2 mb-24">Dados do Cliente</div>
                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                            <mat-label>Conta</mat-label>
                            <input
                                matInput
                                placeholder="Conta da Corretora"
                                [formControl]="numero_xp"
                                name="numero_xp"
                                readonly
                                maxlength="255"
                            />
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between">
                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                            <mat-label>Telefone</mat-label>
                            <input
                                matInput
                                placeholder="Telefone"
                                [formControl]="telefone"
                                readonly
                                name="telefone"
                                mask="(00) 00000-0000"
                            />
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="space-between">
                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                            <mat-label>E-mail</mat-label>
                            <input
                                matInput
                                placeholder="E-mail"
                                [formControl]="email"
                                readonly
                                maxlength="255"
                                name="email"
                            />
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="space-between">
                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                            <mat-label>Sócio</mat-label>
                            <input
                                matInput
                                placeholder="Assessor"
                                [formControl]="assessor_name"
                                name="assessor_id"
                                readonly
                                maxlength="255"
                            />
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="space-between">
                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                            <mat-label>Escritório</mat-label>
                            <input
                                matInput
                                placeholder="Escritório"
                                [formControl]="escritorio"
                                name="escritorio"
                                readonly
                                maxlength="255"
                            />
                        </mat-form-field>
                    </div>
                </div>

                <div class="mat-card mat-elevation-z4 p-24 mr-24" style="width: 50%; float: left">
                    <div class="h2 mb-24">Boleta</div>

                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                        <mat-form-field appearance="outline" fxFlex="100">
                            <mat-label>Estratégia</mat-label>
                            <mat-select
                                placeholder="Estrategias de Renda Variável"
                                [formControl]="estrategia_id"
                                name="estrategia_id"
                                (selectionChange)="onChangeSelectEstrategia()"
                                required
                            >
                                <mat-option value="">Selecione...</mat-option>
                                <mat-option *ngFor="let estrategia of listEstrategia" [value]="estrategia.id">
                                    {{ estrategia.nome }}
                                </mat-option>
                            </mat-select>
                            <mat-spinner diameter="20" *ngIf="loadingSpinnerEstrategia"></mat-spinner>
                            <mat-error *ngIf="estrategia_id.invalid">{{ getErrorEstrategiaMessage() }}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="column" fxLayoutAlign="space-between start" fxLayout.gt-md="row">
                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                            <mat-label>Status</mat-label>
                            <input matInput *ngIf="!existingBoletaID" [formControl]="statusBoleta" [readonly]="true" />
                            <mat-select
                                placeholder="Status"
                                [(value)]="initialValuesCadastroBoleta.status_id"
                                [formControl]="status_id"
                                name="status_id"
                                *ngIf="existingBoletaID"
                            >
                                <mat-option *ngFor="let status of listStatus" [value]="status.id">{{
                                    status.nome
                                }}</mat-option>
                            </mat-select>
                            <mat-spinner diameter="20" *ngIf="loadingSpinnerStatus"></mat-spinner>
                        </mat-form-field>

                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                            <mat-label>Data da Operação</mat-label>
                            <input
                                matInput
                                [matDatepicker]="picker"
                                [formControl]="data_operacao"
                                name="data_operacao"
                                placeholder="Data da Operação"
                            />
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div fxLayout="column" fxLayoutAlign="space-between start" fxLayout.gt-md="row">
                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                            <mat-label>Valor Novo</mat-label>
                            <input
                                matInput
                                placeholder="Valor Novo R$"
                                [formControl]="valor"
                                name="valor"
                                maxlength="100"
                                currencyMask
                                (blur)="atualizaValor()"
                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                            />
                        </mat-form-field>

                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                            <mat-label>Valor Saída de Trades</mat-label>
                            <input
                                matInput
                                placeholder="Valor Saída de Trades R$"
                                [formControl]="valor_trades"
                                name="valor_trades"
                                maxlength="100"
                                readonly
                                currencyMask
                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                            />
                        </mat-form-field>
                    </div>

                    <div fxLayout="column" fxLayoutAlign=" space-between start" fxLayout.gt-md="row">
                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                            <mat-label>Valor Total da Boleta</mat-label>
                            <input
                                matInput
                                placeholder="Valor da Boleta"
                                [formControl]="valor_total_boleta"
                                name="valor_total_boleta"
                                required
                                maxlength="255"
                                currencyMask
                                readonly
                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                            />
                            <mat-error *ngIf="valor.invalid">{{ getErrorVolumeGlobalMessage() }}</mat-error>
                        </mat-form-field>

                        <mat-form-field
                            appearance="outline"
                            floatLabel="always"
                            fxFlex="49"
                            *ngIf="vlr_executado.value != null && vlr_executado.value > 0"
                            style="margin-left: 2%"
                        >
                            <mat-label>Valor Total Executado</mat-label>
                            <input
                                matInput
                                placeholder="Valor Executado"
                                [formControl]="vlr_executado"
                                name="vlr_executado"
                                required
                                currencyMask
                                readonly
                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                            />
                            <mat-error *ngIf="valor.invalid">{{ getErrorVolumeGlobalMessage() }}</mat-error>
                        </mat-form-field>
                    </div>

                    <!--
                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                        <mat-form-field appearance="outline" style="width: 100%" fxFlex="100">
                            <mat-label>Ação Comercial</mat-label>
                            <mat-select             
                                [(value)]="initialValuesCadastroBoleta.acao_comercial_id"
                                [formControl]="acao_comercial_id">
                                <mat-option value="">SELECIONE</mat-option>
                                <mat-option *ngFor="let acaoComercial of listAcaoComercial"
                                    [value]="acaoComercial.id">{{acaoComercial.nome}}</mat-option>
                            </mat-select>
                            <mat-spinner diameter="20" *ngIf="loadingSpinnerAcaoComercial"></mat-spinner> 
                        </mat-form-field>
                    </div>
                    -->

                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                            <mat-label>Observação</mat-label>
                            <textarea
                                matInput
                                placeholder="Observação"
                                [formControl]="observacao"
                                name="observacao"
                                [rows]="5"
                            >
                            </textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div
                fxLayout="row"
                fxLayoutAlign="start"
                fxFlex="1 0 auto"
                style="margin-top: 20px"
                *ngIf="this.valorDetalhadoBoleta"
            >
                <div class="mat-card mat-elevation-z4 p-24 mr-24" style="width: 100%">
                    <div class="h2 mb-24">Composição dos valores da boleta</div>

                    <ngx-datatable
                        #table
                        class="material"
                        [loadingIndicator]="loadingIndicator"
                        [columns]="columns"
                        [columnMode]="'force'"
                        [headerHeight]="50"
                        [footerHeight]="50"
                        [rowHeight]="'auto'"
                        [rows]="rows"
                    >
                        <ngx-datatable-column name="Descrição" prop="ativo" [sortable]="false">
                            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                {{ row.descricao }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Valor" prop="ativo" [sortable]="false">
                            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                R$ {{ row.valor | number: "1.2-2" }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                            <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                                <button mat-icon-button matTooltip="Alterar Valor" (click)="openAlterar(id)">
                                    <mat-icon aria-label="Editar Valor">edit</mat-icon>
                                </button>

                                <button
                                    mat-icon-button
                                    color="warn"
                                    matTooltip="Excluir Valor"
                                    (click)="delete(id)"
                                    *ngIf="user.role_id == 2 || user.role_id == 4 || user.role_id == 7"
                                >
                                    <mat-icon aria-label="Excluir Valor">delete</mat-icon>
                                </button>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>

                    <div style="padding: 5px 10px">
                        <mat-paginator
                            #paginator
                            [length]="length"
                            [pageSize]="pageSize"
                            [pageSizeOptions]="pageSizeOptions"
                            (page)="pageEvent($event)"
                        >
                        </mat-paginator>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
